module.exports = __webpack_public_path__ + "img/toa-login.ad0c8aaa.png";